<template>
  <div class="w-full flex space-x-5">
    <div class="w-full">
      <div class="mb-2 w-full text-grey-900">
        <div class="w-full font-semibold text-left title">Name</div>
        <div class="w-full text-sm h-12 text-left">
          <text-input
            v-model="video.name"
            :validator="$v.video.name"
            attribute="Name"
            placeholder="Enter video name"
          />
        </div>
      </div>
      <div class="mb-2 w-full text-grey-900">
        <div class="w-full font-semibold text-left title">
          Paste your video URL here
        </div>
        <div class="w-full text-sm h-12 text-left">
          <text-input
            v-model="video.video_source"
            :validator="$v.video.video_source"
            attribute="Url"
            placeholder="Youtube, Vimeo video or Mp4 link"
          />
        </div>
      </div>
      <div
        class="w-full flex flex-col items-center text-grey-500 py-5 invisible"
      >
        <span>|</span>
        <span>OR</span>
        <span>|</span>
      </div>
      <div class="mb-2 w-full hidden">
        <div class="w-full font-semibold text-left title">
          Embed Code (coming soon)
        </div>
        <div class="w-full text-sm h-32 text-left">
          <gd-text-area
            v-model="embededCode"
            :validator="$v.embededCode"
            :readonly="true"
          ></gd-text-area>
          <!-- <span class="text-red text-sm">{{ $v.embededCode.$invalid }}</span> -->
        </div>
      </div>
      <div class="mt-6 w-full">
        <gd-button
          :class="[
            !$v.video.$invalid || !$v.embededCode.$invalid
              ? ''
              : 'pointer-events-none',
          ]"
          :disabled="$v.video.$invalid && $v.embededCode.$invalid"
          @click="syncToDB()"
          primary
          >Save</gd-button
        >
      </div>
    </div>
    <div
      class="
        w-full
        border
        preview
        flex
        items-center
        justify-center
        uppercase
        bg-grey-300
        font-bold
        pointer-events-none
      "
    >
      <span class="w-full" v-if="video.thumbnail_url">
        <img class="w-full" :src="video.thumbnail_url" alt="thumbnail" />
      </span>
      <span v-else>Preview Here</span>
    </div>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
import { required, url } from 'vuelidate/lib/validators';
import GdButton from '../Button';
import GdTextArea from '../TextArea';
import mixins from '../../mixins';
import parseVideoHelper from './helpers/parseVideo';

export default {
  name: 'ExternalVideos',
  mixins: [mixins],
  props: {
    dark: {},
  },
  data() {
    return {
      youtubeUrl: 'https://www.youtube.com/embed/',
      vimeoUrl: 'https://player.vimeo.com/video/',
      grooveVideoUrl: 'https://app.groove.cm/groovevideo/video',
      embededCode: '',
      video: {
        name: 'default-name',
        category_id: 1,
        video_source: '',
        video_source_type: 1,
        thumbnail_url: '',
      },
    };
  },
  computed: {},
  validations: {
    embededCode: {
      required,
    },
    video: {
      name: {
        required,
      },
      video_source: {
        required,
        url,
      },
    },
  },
  components: {
    GdButton,
    GdTextArea,
  },
  mounted() {},
  methods: {
    async syncToDB() {
      this.$v.$touch();

      try {
        if (this.$v.video.$invalid) {
          throw new Error('Invalid Data');
        }

        await api.post(
          `${window.config.apiCoreUrl}/groovevideo/videos`,
          { ...this.video },
          true
        );

        this.$emit('sendBackToLibrary', true);
      } catch (err) {
        /** */
      }
    },
  },
  watch: {
    'video.video_source': {
      async handler(newValue) {
        try {
          const { type, id } = parseVideoHelper(newValue);

          this.video.video_source_type = ['youtube'].includes(type) ? 2 : 3;

          if (type === 'youtube') {
            this.video.thumbnail_url = `https://img.youtube.com/vi/${id}/sddefault.jpg`;
          } else if (type === 'vimeo') {
            this.video.thumbnail_url = await fetch(
              `http://vimeo.com/api/oembed.json?url=http%3A//vimeo.com/${id}`
            )
              .then((response) => response.json())
              .then((d) => d.thumbnail_url);
          } else {
            this.video.thumbnail_url =
              'https://img.youtube.com/vi/false/sddefault.jpg';
          }
        } catch (err) {
          this.video.thumbnail_url =
            'https://img.youtube.com/vi/false/sddefault.jpg';
        }
      },
    },
    embededCode(newValue, oldValue) {},
  },
};
</script>